import React, { useEffect, useRef, useState } from "react";
import { TDaySortKey } from "../../../../../../domain/codecs/DaySortKey";
import { CRMIcon } from "../../../CRMIcon/CRMIcon";

type TProps = {
    value: TDaySortKey;
    onChange: (value: TDaySortKey) => void;
};

const options: Array<{ key: TDaySortKey, label: string }> = [
    { key: "priority", label: "Priority" },
    { key: "expected_exchange_date", label: "Expected exchange" },
    { key: "expected_completion_date", label: "Expected completion" },
    { key: "exchange_deadline_date", label: "Exchange deadline" },
    { key: "completion_deadline_date", label: "Completion deadline" },
];

const labelFor = (value: TDaySortKey): string =>
    options.find((option) => option.key === value)?.label ?? "Priority";

export const CRMDaySortFilter = (props: TProps): JSX.Element => {
    const [isOpen, setIsOpen] = useState(false);
    const wrapRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!isOpen) {
            return;
        }
        const onDocMouseDown = (event: MouseEvent) => {
            if (
                wrapRef.current
                && event.target instanceof Node
                && !wrapRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", onDocMouseDown);
        return () => document.removeEventListener("mousedown", onDocMouseDown);
    }, [isOpen]);

    const select = (value: TDaySortKey) => {
        props.onChange(value);
        setIsOpen(false);
    };

    return (
        <div className="crm-day-sort-filter" ref={wrapRef}>
            {/* FACE */}
            <div
                className="crm-day-sort-filter__face"
                onClick={() => setIsOpen((open) => !open)}
                tabIndex={0}
            >
                <div className="crm-day-sort-filter__face-text">
                    Sort: {labelFor(props.value)}
                </div>
                <CRMIcon iconName={isOpen ? "up-arrow" : "down-arrow"} colour="neutral-0" size="tiny" />
            </div>

            {/* PANEL */}
            {isOpen && (
                <div className="crm-day-sort-filter__panel">
                    {options.map((option) => (
                        <div
                            key={option.key}
                            className={`crm-day-sort-filter__option ${option.key === "priority" ? "crm-day-sort-filter__option--default" : ""} ${props.value === option.key ? "crm-day-sort-filter__option--selected" : ""}`}
                            onClick={() => select(option.key)}
                        >
                            <span className="crm-day-sort-filter__option-text">
                                {option.label}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
